import { useTranslation } from "react-i18next";

import { Agreements, CommunicationEvents, Services } from "modules/AppointmentDetails/components/KeylockerCommunicationLog/components";
import { useAppointmentLocation } from "modules/AppointmentDetails/hooks";

import type { Appointment, KeyLockerCommunication } from "models";

type ContentProps = {
  appointment: Appointment;
  comm: KeyLockerCommunication;
};

export const Content = ({ comm }: ContentProps) => {
  const { t } = useTranslation();
  const selectedLocation = useAppointmentLocation();

  const { events, agreed_interventions, agreements } = comm;

  return (
    <>
      <CommunicationEvents comm={comm} events={events} />
      <Services services={agreed_interventions} title={t("v8_accepted_scheduled_services", "Accepted scheduled services")} vat={selectedLocation?.vat} />
      <Agreements agreements={agreements} />
    </>
  );
};
